export const moatParamBuilder = (params, pagingParams, defaultFilter) => {
    let currentPage = pagingParams.page
    params.startRow === 0 ? (currentPage = 1) : currentPage++
    let localParams = {
        FC: [],
        FT: [],
        FV: [],
    }
    if (params.sortModel.length > 0) {
        localParams.SC = params.sortModel.map((sort) => sort.colId)
        localParams.SD = params.sortModel.map((sort) => (sort.sort === 'asc' ? 1 : -1))
        localParams.SP = params.sortModel.map((sort) => (sort.priority ? sort.priority : 1))
    }

    let filterType = detectFilterModelType(params.filterModel)

    if (filterType === 'advanced') {
        localParams = { ...localParams, ...buildAdvancedFilterModel(params.filterModel) }
    } else {
        localParams = { ...localParams, ...buildStandardFilterModel(params.filterModel) }
    }

    if (defaultFilter) {
        localParams['FC'].push(defaultFilter.FC)
        localParams['FT'].push(defaultFilter.FT)
        localParams['FV'].push(defaultFilter.FV)
    }

    localParams.page_size = pagingParams.page_size
    localParams.last_row_num = params.startRow
    localParams.page = currentPage
    return localParams
}

const detectFilterModelType = (filterModel) => {
    if (filterModel && typeof filterModel === 'object' && 'filterType' in filterModel) {
        return 'advanced'
    }
    return 'standard'
}

export const buildAdvancedFilterModel = (filterModel) => {
    let localParams = {
        FC: [],
        FT: [],
        FV: [],
        FG: [],
        FO: [],
    }

    if (filterModel.filterType === 'join') {
        let openParen = '('
        for (const condition of filterModel.conditions) {
            const subGroup = buildAdvancedFilterModel(condition)
            localParams['FC'].push(...subGroup['FC'])
            localParams['FT'].push(...subGroup['FT'])
            localParams['FV'].push(...subGroup['FV'])
            localParams['FO'].push(...subGroup['FO'])

            if (subGroup['FG'].length > 0) {
                openParen += subGroup['FG'][0]
            }
            localParams['FG'].push(openParen.trim())
            openParen = ' '
            if (subGroup['FG'].length > 1) {
                localParams['FG'].push(...subGroup['FG'].slice(1))
            }

            localParams['FO'].push(filterModel.type)
        }
        localParams['FO'].pop()
        let closeParen = localParams['FG'].pop()
        closeParen += ')'
        localParams['FG'].push(closeParen.trim())
    } else {
        const formattedType = formatFilterType(filterModel.type)
        let rawValue = filterModel.filter

        // Advanced date filters may supply dateFrom / dateTo instead of a single
        // `filter` property.
        if (
            (filterModel.filterType === 'date' || formattedType === 'dt_range') &&
            rawValue === undefined
        ) {
            if (filterModel.dateFrom !== undefined && filterModel.dateTo !== undefined) {
                rawValue = `${filterModel.dateFrom}|${filterModel.dateTo}`
            } else if (filterModel.dateFrom !== undefined) {
                rawValue = filterModel.dateFrom
            }
        }

        // Fallback to empty string to avoid runtime errors downstream.
        rawValue = rawValue ?? ''

        localParams['FC'].push(filterModel.colId)
        localParams['FT'].push(formattedType)
        localParams['FV'].push(formatFilterValue(formattedType, rawValue))
    }

    return localParams
}

const buildStandardFilterModel = (filterModel) => {
    let localParams = {
        FC: [],
        FT: [],
        FV: [],
    }

    if (Object.keys(filterModel).length > 0) {
        localParams['FC'] = Object.keys(filterModel)
        localParams['FT'] = Object.values(filterModel).map((st, index) => {
            // Special case for prune filter with set type - use 'eq' instead of 'incl'
            if (st.filterType === 'set' && localParams['FC'][index] === 'prune') {
                return 'eq'
            }
            return formatFilterType(st.type ? st.type : st.filterType)
        })
        localParams['FV'] = Object.values(filterModel).map((st) => {
            if (st.filterType === 'set') {
                return st.values.join('~')
            } else if (st.filterType === 'date') {
                return formatFilterValue(
                    formatFilterType(st.type),
                    st.dateTo ? st.dateFrom + '|' + st.dateTo : st.dateFrom
                )
            } else {
                return formatFilterValue(formatFilterType(st.type), st.filter)
            }
        })
    }

    return localParams
}

// Not all of these types are valid at this time
const formatFilterType = (type) => {
    if (!type) {
        throw new Error('No filter type to format')
    }
    // type can be passed with various casing. Normalize to lower to match map key casing.
    const typeMap = {
        'date range': 'dt_range',
        'date-time range': 'dt_range',
        equals: 'eq',
        greaterThan: 'gt',
        includes: 'incl',
        lessThan: 'lt',
        inRange: 'dt_range',
        startsWith: 'complex_start',
        contains: 'complex_text',
        empty: 'empty',
        set: 'incl',
        // notIncludes: 'not_incl',
    }
    // assign to avoid repeat map lookup on the happy path.
    const typeString = typeMap[type]

    if (typeString) return typeString

    throw new Error(`No type mapped for '${type}'`)
}

// Not all of these values are valid at this time
const formatFilterValue = (filterType, filterValue) => {
    switch (filterType.toLowerCase()) {
        case 'dt_range':
            const vals = filterValue.split('|')
            const first = vals[0].includes('T') ? vals[0].split('T')[0] : vals[0]
            const second = vals[1].includes('T') ? vals[1].split('T')[0] : vals[1]
            return first + '~' + second
        // case 'date-time range': {
        //     const vals = filterValue.split('|')
        //     return vals[0] + '~' + vals[1]
        // }
        case 'includes':
        case 'range':
            return filterValue.replace('|', '~')
        default:
            return filterValue
    }
}
